import { ChildRef } from "../../../../../lib/web/components/child-ref";
import { ChildrenRef } from "../../../../../lib/web/components/children-ref";
import { ClickListener } from "../../../../../lib/web/components/click-listener";
import { Component } from "../../../../../lib/web/components/component";
import { ComponentBase } from "../../../../../lib/web/components/component-base";
import { DataEventService } from "../../../services/data-event.service";
import { MediaPlayerService } from "../../../services/media-player.service";
import { DiscoveryAssistantStep } from "../../pages/discovery-assistant/discovery-assistant.component";

@Component({
    selector: '.o-discovery-assistant-result'
})
export class DiscoveryAssistantResultComponent extends ComponentBase<HTMLElement> implements DiscoveryAssistantStep {
   
    private _assistant: any = null;
    private _interestClusters: any[] = null;
    private _interestCluster: any = null;

    @ChildRef('.o-discovery-assistant-result__clusterDescription')
    private _clusterDescription: HTMLDivElement = null;
    @ChildrenRef(HTMLDivElement, '.o-discovery-assistant-result__clusterContent')
    private _clusterContents: HTMLDivElement[] = null;
    
    public constructor(node: HTMLElement, private _mediaPlayerService: MediaPlayerService, private _dataEventService: DataEventService) {
        super(node);
    }   

    @ClickListener('.o-discovery-assistant-result__back')
    public back(): void {
        window.dispatchEvent(new CustomEvent('discovery-assistant-reset'));
    }

    @ClickListener('.o-discovery-assistant-result__clusterContent')
    public onClickContent(e: MouseEvent): void {
        this.playContent(this._clusterContents.indexOf(e.currentTarget as HTMLDivElement));
    }

    @ClickListener('.o-discovery-assistant-result__footer button')
    public onAccess(): void {
        this._dataEventService.onboardingRegister(this._interestCluster.id);
        window.location.assign(this._interestCluster.formUrl);
    }

    public onInit(): void {
        super.onInit();

        this._clusterContents.forEach(c => c.classList.remove('o-discovery-assistant-result__clusterContent--show'))
    }

    private setCluster(): void {
        this.checkCluster();
        this._clusterDescription.innerText = this._interestCluster.description;

        const contents: any[] = this.contents;
        
        contents.forEach((content, index) => {
            const clusterContent: HTMLDivElement = this._clusterContents[index];
            clusterContent.classList.add('o-discovery-assistant-result__clusterContent--show');
            clusterContent.querySelector('img').src = content.img;
            clusterContent.querySelector<HTMLDivElement>('.o-discovery-assistant-result__clusterContentTitle').innerText = content.title;
        });
    }

    private checkCluster(): void {        
        const interestClusterId: number = this._assistant.assignments?.find((a: any) => a.key?.toLowerCase() === this._assistant.answers?.join('').toLowerCase())?.cluster;
        const interestCluster = interestClusterId ? this._interestClusters.find(c => c.id === interestClusterId): this._interestClusters[Math.floor(Math.random() * this._interestClusters.length)];
        this._interestCluster = interestCluster;
    }

    private playContent(index: number): void {
        const content: any = this.contents[index];
        if (content) {
            this._mediaPlayerService.loadMedia('brightcove',{
                capsuleId: content.type === 'capsule' ? content.id: null,
                collectionId: content.type === 'collection' ? content.id: null,
                type: 'trailer',
                image: content.img,
                controls: {
                    miniPlayer: 'disable',
                    chromecast: false,
                }              
            });
        }
        this._dataEventService.onboardingStartVideo(this._interestCluster.id, content.trailerId);
    }

    public get contents(): any[] {
        return this._interestCluster.content?.slice(0, 3)?.filter((c: any) => !!c.trailerId) || [];
    }

    public enter(assistant: any, interestClusters: any[]): void {        
        this._assistant = assistant;
        this._interestClusters = interestClusters;
        this.setCluster();
        this._dataEventService.onboardingResult(this.contents.map(c => c.trailerId), this._interestCluster.id);
    }

    public exit(): void {
    }
}